module.exports = __webpack_public_path__ + "img/2.a55e59da.jpg";